import { useOptionalUserPreferences } from '../providers/UserPreferencesProvider'

/**
 * The IANA timezone dates should be rendered in.
 *
 * The person's chosen zone when they have one — in this browser, or on their
 * account — and otherwise the browser's own. Not `preferences.timezone`
 * directly: with nothing chosen that resolves to the 'UTC' system default,
 * which rendered every date in UTC for anyone who had never opened the
 * preferences page. The provider knows whether the value is a choice; ask it.
 *
 * Works without a provider too (browser zone): this is display-only with a
 * sane default, and a date cell must not crash a component rendered in
 * isolation. Import from `@airclou/shell/timezone` in a file that needs
 * nothing else from the shell — the package index pulls in the i18n provider,
 * which tests that stub `react-i18next` cannot load.
 */
export function useTimezone(): string {
  const prefs = useOptionalUserPreferences()
  if (prefs && prefs.isChosen('timezone') && prefs.preferences.timezone) return prefs.preferences.timezone
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'
  } catch {
    return 'UTC'
  }
}
